import { render, staticRenderFns } from "./CaracteristicasProduto.vue?vue&type=template&id=3dfe2e34&scoped=true&"
import script from "./CaracteristicasProduto.vue?vue&type=script&lang=js&"
export * from "./CaracteristicasProduto.vue?vue&type=script&lang=js&"
import style0 from "./CaracteristicasProduto.vue?vue&type=style&index=0&id=3dfe2e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfe2e34",
  null
  
)

export default component.exports